import { observer } from 'mobx-react-lite'
import React, { useRef } from 'react'
import { ListsStoreContext, ListsStore } from 'src/store/lists/ListsStore'
import {
  AddToListStage,
  AddToListStore,
  AddToListStoreContext,
} from 'src/store/lists/AddToListStore'
import ListScreen from './components/ListScreen'
import AddToListScreen from './components/AddToList/AddToListScreen'

enum Mode {
  LIST_SCREEN,
  ADD_PARTS,
}

const Lists = observer((): React.ReactElement => {
  const listStore = useRef<ListsStore>(new ListsStore())
  const addToListStore = useRef<AddToListStore>(new AddToListStore())

  const showAddToListMode =
    addToListStore.current.getStage() > AddToListStage.CHOOSE_METHOD

  const mode = showAddToListMode ? Mode.ADD_PARTS : Mode.LIST_SCREEN

  return (
    <ListsStoreContext.Provider value={listStore.current}>
      <AddToListStoreContext.Provider value={addToListStore.current}>
        {mode == Mode.ADD_PARTS && <AddToListScreen />}
        {mode == Mode.LIST_SCREEN && <ListScreen />}
      </AddToListStoreContext.Provider>
    </ListsStoreContext.Provider>
  )
})

export default Lists
